/* ============================================================
   LUXE PARIS — Theme JS (vanilla, lightweight, no dependencies)
   ============================================================ */
(function () {
  'use strict';

  var CFG = window.LuxeParis || {};
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* ---------- Money formatter (Shopify standard) ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || CFG.moneyFormat || '${{amount}}';

    function defaultOption(opt, def) { return (typeof opt === 'undefined' ? def : opt); }
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal = defaultOption(decimal, '.');
      if (isNaN(number) || number == null) return 0;
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var cents = parts[1] ? decimal + parts[1] : '';
      return dollars + cents;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount': value = formatWithDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = formatWithDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = formatWithDelimiters(cents, 2, '.', ','); break;
      case 'amount_with_space_separator': value = formatWithDelimiters(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ','); break;
      case 'amount_no_decimals_with_space_separator': value = formatWithDelimiters(cents, 0, ' '); break;
      case 'amount_with_apostrophe_separator': value = formatWithDelimiters(cents, 2, "'"); break;
      default: value = formatWithDelimiters(cents, 2);
    }
    return formatString.replace(placeholderRegex, value);
  }

  /* ---------- Header scroll state ---------- */
  var header = document.querySelector('.site-header');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 10); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Mobile nav drawer ---------- */
  var burger = document.querySelector('[data-nav-toggle]');
  var navDrawer = document.querySelector('.nav-drawer');
  var navOverlay = document.querySelector('.drawer-overlay');
  function closeNav() {
    if (navDrawer) navDrawer.classList.remove('is-open');
    if (navOverlay) navOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  if (burger && navDrawer) {
    burger.addEventListener('click', function () {
      var open = navDrawer.classList.toggle('is-open');
      if (navOverlay) navOverlay.classList.toggle('is-open', open);
      document.body.style.overflow = open ? 'hidden' : '';
    });
  }
  if (navOverlay) navOverlay.addEventListener('click', closeNav);

  /* ---------- Reveal on scroll ---------- */
  var reveals = document.querySelectorAll('.reveal');
  if (reveals.length && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); io.unobserve(entry.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    reveals.forEach(function (el) { io.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* ============================================================
     CART DRAWER
     ============================================================ */
  var drawer = document.getElementById('CartDrawer');
  var cartOverlay = document.querySelector('.cart-drawer-overlay');

  function openCart() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    if (cartOverlay) { cartOverlay.hidden = false; requestAnimationFrame(function () { cartOverlay.classList.add('is-open'); }); }
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (cartOverlay) { cartOverlay.classList.remove('is-open'); setTimeout(function () { cartOverlay.hidden = true; }, 400); }
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-close]')) { closeCart(); }
    if (e.target.closest('[data-cart-toggle]')) { e.preventDefault(); openCart(); }
  });
  document.addEventListener('keyup', function (e) { if (e.key === 'Escape') { closeNav(); closeCart(); } });

  /* ---------- Build a cart line item (mirrors cart-drawer-item.liquid) ---------- */
  function itemHTML(item, line) {
    var img = item.image
      ? '<img src="' + item.image.replace(/(\.[^.\/]+)(\?|$)/, '_200x$1$2') + '" alt="' + escapeHtml(item.product_title) + '" width="100" height="100" loading="lazy">'
      : '';
    var variant = (item.product_has_only_default_variant)
      ? ''
      : '<div class="cart-item-drawer__variant">' + escapeHtml(item.variant_title || '') + '</div>';
    return '' +
      '<div class="cart-item-drawer" data-line="' + line + '" data-key="' + item.key + '">' +
        '<a href="' + item.url + '" class="cart-item-drawer__media" data-cart-close>' + img + '</a>' +
        '<div class="cart-item-drawer__main">' +
          '<a href="' + item.url + '" class="cart-item-drawer__title" data-cart-close>' + escapeHtml(item.product_title) + '</a>' +
          variant +
          '<div class="cart-item-drawer__price">' + formatMoney(item.final_price) + '</div>' +
          '<div class="cart-item-drawer__controls">' +
            '<div class="qty-selector qty-selector--sm">' +
              '<button type="button" data-line-change="down" aria-label="Decrease">&minus;</button>' +
              '<span class="cart-item-drawer__qty" data-line-qty>' + item.quantity + '</span>' +
              '<button type="button" data-line-change="up" aria-label="Increase">&plus;</button>' +
            '</div>' +
            '<button type="button" class="cart-item-drawer__remove" data-line-remove>' + (CFG.strings && CFG.strings.remove || 'Remove') + '</button>' +
          '</div>' +
        '</div>' +
      '</div>';
  }
  function escapeHtml(s) {
    return String(s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  /* ---------- Render whole cart into drawer ---------- */
  function renderCart(cart) {
    updateBadge(cart.item_count);
    var itemsEl = drawer && drawer.querySelector('[data-cart-items]');
    var emptyEl = drawer && drawer.querySelector('[data-cart-empty]');
    var footerEl = drawer && drawer.querySelector('[data-cart-footer]');
    var totalEl = drawer && drawer.querySelector('[data-cart-total]');
    var countText = drawer && drawer.querySelector('[data-cart-count-text]');

    if (countText) countText.textContent = cart.item_count;
    if (itemsEl) {
      itemsEl.innerHTML = cart.items.map(function (item, i) { return itemHTML(item, i + 1); }).join('');
    }
    if (cart.item_count > 0) {
      if (emptyEl) emptyEl.hidden = true;
      if (footerEl) footerEl.hidden = false;
      if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
    } else {
      if (emptyEl) emptyEl.hidden = false;
      if (footerEl) footerEl.hidden = true;
    }
  }

  function updateBadge(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count < 1;
    });
  }

  function fetchCart() {
    return fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }

  /* ---------- Change line quantity ---------- */
  function changeLine(line, quantity) {
    return fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(function (cart) { renderCart(cart); return cart; });
  }

  if (drawer) {
    drawer.addEventListener('click', function (e) {
      var row = e.target.closest('[data-line]');
      if (!row) return;
      var line = parseInt(row.getAttribute('data-line'), 10);
      var qtyEl = row.querySelector('[data-line-qty]');
      var current = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;

      if (e.target.closest('[data-line-remove]')) { changeLine(line, 0); }
      else if (e.target.closest('[data-line-change="up"]')) { changeLine(line, current + 1); }
      else if (e.target.closest('[data-line-change="down"]')) { changeLine(line, Math.max(0, current - 1)); }
    });
  }

  /* ---------- Quantity steppers (non-drawer, e.g. product page) ---------- */
  document.querySelectorAll('[data-qty]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    if (!input) return;
    wrap.querySelectorAll('button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var step = btn.getAttribute('data-qty-change') === 'up' ? 1 : -1;
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) + step);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  /* ---------- Add to cart (AJAX) → open drawer + update badge ---------- */
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      if (form.getAttribute('data-ajax') !== 'true') return;
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      var label = btn ? btn.querySelector('[data-buy-text]') || btn : null;
      var original = label ? label.textContent : '';
      if (btn) { btn.classList.add('is-loading'); btn.disabled = true; }
      if (label) label.textContent = btn && btn.getAttribute('data-adding') || 'Adding…';

      fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
        .then(function (res) {
          if (btn) { btn.classList.remove('is-loading'); btn.disabled = false; }
          if (label) label.textContent = original;
          if (!res.ok) { return; }
          return fetchCart().then(function (cart) { renderCart(cart); openCart(); });
        })
        .catch(function () {
          if (btn) { btn.classList.remove('is-loading'); btn.disabled = false; }
          if (label) label.textContent = original;
          form.submit();
        });
    });
  });

  /* ---------- Product gallery ---------- */
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var mainImg = gallery.querySelector('[data-gallery-main]');
    var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var full = thumb.getAttribute('data-full');
        if (mainImg && full) { mainImg.src = full; mainImg.alt = thumb.getAttribute('data-alt') || ''; }
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  });

  /* ---------- Sticky add to cart ---------- */
  var stickyBar = document.querySelector('[data-sticky-atc]');
  var formAtc = document.querySelector('[data-product-form] [type="submit"]');
  if (stickyBar && formAtc && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) { stickyBar.classList.toggle('is-visible', !entry.isIntersecting); });
    }, { threshold: 0 }).observe(formAtc);
    var stickyBtn = stickyBar.querySelector('[data-sticky-submit]');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        var realForm = document.querySelector('[data-product-form]');
        if (realForm && realForm.requestSubmit) realForm.requestSubmit();
        else if (realForm) { var s = realForm.querySelector('[type="submit"]'); if (s) s.click(); }
      });
    }
  }

})();
